/* global axios */
import ApiClient from '../ApiClient';

class LeadTasksAPI extends ApiClient {
  constructor() {
    super('lead_tasks', { accountScoped: true });
  }

  // params: { lead_id, status, assignee_id }
  get(params = {}) {
    const entries = Object.entries(params).filter(
      ([, value]) => value !== '' && value !== null && value !== undefined
    );
    const query = entries.length
      ? `?${new URLSearchParams(entries).toString()}`
      : '';
    return axios.get(`${this.url}${query}`);
  }

  complete(taskId, data = {}) {
    return axios.patch(`${this.url}/${taskId}/complete`, data);
  }

  // Conteo de tareas pendientes/vencidas por lead (para indicadores en LeadCard).
  stats(params = {}) {
    const entries = Object.entries(params).filter(
      ([, value]) => value !== '' && value !== null && value !== undefined
    );
    const query = entries.length
      ? `?${new URLSearchParams(entries).toString()}`
      : '';
    return axios.get(`${this.url}/stats${query}`);
  }
}

export default new LeadTasksAPI();
